/*
 * Cart countdown (Marlow & Grace) — subtiele aflopende timer in de cart.
 * Eindtijd staat per SESSIE vast in sessionStorage, dus:
 *  - hij telt door over paginawissels/morphs heen (geen reset, geen "springen");
 *  - hij start NIET opnieuw als hij in dezelfde sessie al is afgelopen;
 *  - een nieuwe browsersessie (tab opnieuw) begint vers.
 * Custom element wordt globaal gedefinieerd, zodat een via Horizon-morph
 * opnieuw ingevoegd <cart-countdown> automatisch upgrade en doortelt.
 */
(function () {
  if (customElements.get('cart-countdown')) return;

  var KEY = 'os_cart_countdown_end';

  class CartCountdown extends HTMLElement {
    connectedCallback() {
      var mins = parseInt(this.dataset.minutes || '10', 10);
      var now = Date.now();
      var stored = sessionStorage.getItem(KEY);
      var end;

      if (stored) {
        end = parseInt(stored, 10);
        if (!end || now >= end) {
          // al afgelopen deze sessie -> niet opnieuw starten
          this.hidden = true;
          return;
        }
      } else {
        end = now + mins * 60 * 1000;
        sessionStorage.setItem(KEY, String(end));
      }

      this.end = end;
      this.timeEl = this.querySelector('[data-countdown]');
      this.hidden = false;
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var left = Math.max(0, this.end - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      if (this.timeEl) this.timeEl.textContent = m + ':' + (s < 10 ? '0' + s : s);
      if (left <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
      }
    }
  }

  customElements.define('cart-countdown', CartCountdown);
})();
